import { useState } from 'react';
import { useChatStore } from '../store/useChatStore';

// "Set GQ Token" control + modal, extracted from the standalone app's NavBar.
// The token is held in memory only (never persisted), and forwarded to the backend
// as the X-GQ-ApiToken header on each request.
export default function SetTokenButton() {
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [tokenDraft, setTokenDraft] = useState('');
  const { gqApiToken, setGqApiToken } = useChatStore();

  const saveToken = () => {
    setGqApiToken(tokenDraft);
    setShowTokenModal(false);
  };

  return (
    <>
      <button
        onClick={() => { setTokenDraft(gqApiToken); setShowTokenModal(true); }}
        title="Set GQ API Token"
        aria-label="Set GQ API Token"
        style={{
          display: 'flex', alignItems: 'center', gap: 5,
          background: gqApiToken ? 'var(--gqs-success-soft)' : 'var(--gqs-hover)',
          border: `1px solid ${gqApiToken ? 'var(--gqs-success-border)' : 'var(--gqs-border)'}`,
          borderRadius: 6,
          padding: '4px 10px',
          cursor: 'pointer',
          color: gqApiToken ? 'var(--gqs-success)' : 'var(--gqs-text-muted)',
          fontSize: 12,
        }}
      >
        <span style={{ width: 7, height: 7, borderRadius: '50%', background: gqApiToken ? 'var(--gqs-success)' : 'var(--gqs-text-muted)', display: 'inline-block' }} />
        {gqApiToken ? 'Token set' : 'Set GQ Token'}
      </button>

      {showTokenModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'var(--gqs-overlay)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000,
        }}>
          <div style={{
            background: 'var(--gqs-surface-raised)',
            border: '1px solid var(--gqs-border)',
            borderRadius: 10,
            padding: 24,
            width: 400,
            display: 'flex', flexDirection: 'column', gap: 14,
            color: 'var(--gqs-text)',
          }}>
            <h2 style={{ fontSize: 15, fontWeight: 600 }}>GQ API Token</h2>
            <p style={{ color: 'var(--gqs-text-muted)', fontSize: 13 }}>
              Stored in memory only — not persisted or sent anywhere except the backend proxy.
            </p>
            <input
              type="password"
              placeholder="Paste your GQ API token…"
              value={tokenDraft}
              onChange={(e) => setTokenDraft(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && saveToken()}
              autoFocus
              style={{
                background: 'var(--gqs-bg)',
                border: '1px solid var(--gqs-border)',
                borderRadius: 6,
                padding: '8px 12px',
                color: 'var(--gqs-text)',
                fontSize: 13,
                outline: 'none',
              }}
            />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowTokenModal(false)} style={{
                background: 'transparent', border: '1px solid var(--gqs-border)', borderRadius: 6,
                padding: '7px 16px', color: 'var(--gqs-text-muted)', cursor: 'pointer', fontSize: 13,
              }}>Cancel</button>
              <button onClick={saveToken} style={{
                background: 'var(--gqs-accent-solid)', border: 'none', borderRadius: 6,
                padding: '7px 16px', color: 'var(--gqs-on-accent)', cursor: 'pointer', fontSize: 13, fontWeight: 600,
              }}>Save</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
